import { apiClient } from './client';

export type SupportReportCategory = 'BUG' | 'BLOCKING';

export interface SubmitSupportReportRequest {
  category: SupportReportCategory;
  message: string;
  path?: string | null;
  userAgent?: string | null;
  appVersion?: string | null;
}

export const supportApi = {
  async submitReport(request: SubmitSupportReportRequest): Promise<void> {
    await apiClient.post<void>('/v1/support/reports', request);
  },
};
